import { ButtonColorVariant, ButtonVariant } from "@/components/ui/button";
import { ReactNode } from "react";

export enum ConfirmationType {
  Keyword = "keyword",
  Name = "name",
}

export interface BaseConfirmDialogProps {
  open: boolean;
  title?: string;
  description?: string | ReactNode;
  customComponent?: ReactNode;
  labelCancel?: string;
  labelConfirm?: string;
  onCancel: () => void;
  onConfirm: () => void;
  requireConfirmation?: boolean;
  confirmationPlaceholder?: string;
  confirmationLabel?: string;
  expectedConfirmationText?: string;
  cancelVariant?: ButtonVariant;
  confirmVariant?: ButtonVariant;
  confirmColorVariant?: ButtonColorVariant;
}
